import './toolbarButton.scss'
import templateUrl from './toolbarButton.html'

/**
 * A responsive flat button for the toolbar
 *
 * @example
 * <tmr-toolbar-button
 *   label="SOME.TRANSLATION.KEY"
 *   icon="o-gear-1"
 *   ng-click=""
 *   ng-disabled=""
 * ></tmr-toolbar-button>
 *
 * @type {ngComponent}
 * @prop {string} icon
 * @prop {string} label
 * @prop {string=} button-class
 * @prop {string=} [shrinks-under='gt-sm']
 * @prop {boolean=} [ng-disabled=false]
 */
export const tmrToolbarButton = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrToolbarButtonController',
  bindings: {
    icon: '@',
    label: '@',
    buttonClass: '@?',
    shrinksUnder: '@?',
    ngDisabled: '<?',
  },
}

/**
 * Controller of component {@link tmrToolbarButton}
 *
 * @type {ngController}
 */
export class tmrToolbarButtonController {
  static ngType = 'controller'

  constructor($mdMedia) {
    'ngInject'
    Object.assign(this, { $mdMedia })
  }

  $onInit() {
    this.shrinksUnder = this.shrinksUnder ?? 'gt-sm'
  }

  shrinks() {
    return !this.$mdMedia(this.shrinksUnder)
  }
}
